import React from 'react'
import MealCard from '../../../components/MealCard'

import SKELETON_DATA from './skeletonData'

const Meals = props => {
  const {
    isLoading,
    menu,
    order,
    addProduct,
    removeProduct,
    history,
    selectedCategoryId
  } = props

  const selectedCategory = menu.find(
    category => category.id === selectedCategoryId
  )

  const meals = selectedCategory ? selectedCategory.meals : []

  const onMealClick = id => {
    history.push(`/products/${id}`)
  }

  return (
    <section className="cookunity__menu__content">
      <div className="cookunity__wrapper">
        <div className="cookunity__menu__content__items">
          {(isLoading ? Array(10).fill(SKELETON_DATA) : meals).map(
            (meal, i) => {
              const mealInOrder = order.find(m => m.id === meal.id)
              const qtyOrdered = mealInOrder ? mealInOrder.qty : 0

              return (
                <MealCard
                  isLoading={isLoading}
                  id={meal.id}
                  key={isLoading ? `${meal.id}-${i}-loading` : meal.id}
                  className="cookunity__menu__content__items__item"
                  stars={meal.stars}
                  chefImage={meal.chefImage}
                  mealImage={meal.mealImage}
                  mealName={meal.name}
                  mealDescription={meal.short_description}
                  chefName={meal.chefName}
                  calories={meal.calories}
                  newChef={meal.new_chef}
                  newDish={meal.new_meal}
                  showPrice
                  price={meal.formattedPrice}
                  canEdit
                  addProduct={() => addProduct(meal)}
                  removeProduct={() => removeProduct(meal)}
                  qtyOrdered={qtyOrdered}
                  qtyTotal={meal.stock}
                  onMealClick={() => onMealClick(meal.id)}
                />
              )
            }
          )}
        </div>
      </div>
    </section>
  )
}

export default Meals



// WEBPACK FOOTER //
// ./src/modules/Menu/Meals/Meals.jsx